<template>
  <div class="login-page">
    <div class="login-container">
      <div class="login-header">
        <h1>贞吉跑腿管理后台</h1>
        <p>请登录您的账号</p>
      </div>
      <form class="login-form" @submit.prevent="handleSubmit">
        <div class="form-group">
          <label>用户名</label>
          <input 
            type="text" 
            v-model="form.username" 
            placeholder="请输入用户名"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label>密码</label>
          <input 
            type="password" 
            v-model="form.password" 
            placeholder="请输入密码"
            class="form-control"
          />
        </div>
        <button type="submit" class="login-btn">登录</button>
      </form>
      <div class="login-footer">
        <span @click="goInstall">首次部署？初始化管理员</span>
      </div>
    </div>
  </div>
</template>

<script>
import { adminLogin } from '@/api/system'
import { setToken, setAdminInfo } from '@/utils/auth'

export default {
  name: 'Login',
  data() {
    return {
      form: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    goInstall() {
      this.$router.push('/install')
    },
    async handleSubmit() {
      if (!this.form.username || !this.form.password) {
        alert('请输入用户名和密码')
        return
      }
      try {
        const res = await adminLogin({
          username: this.form.username,
          password: this.form.password
        })
        // res 已是 { code, message, data:{ token, admin } }
        if (res.code !== 0 || !res.data || !res.data.token) {
          alert(res.message || '登录失败')
          return
        }
        const { token, admin } = res.data
        setToken(token)
        setAdminInfo(admin)
        // 写入 Vuex store，供页面（如"当前操作员"）直接读取，避免仅依赖路由守卫二次请求
        this.$store.commit('user/SET_USER', admin)
        // 写入细粒度权限标识，供 v-permission 指令读取
        this.$store.dispatch('permission/setPermission', admin.permissions || [])
        // 顶栏展示用真实姓名，回退到登录账号
        localStorage.setItem('admin_username', admin.real_name || admin.username)
        this.$router.push('/')
      } catch (err) {
        const msg = err && err.response && err.response.data && err.response.data.message
        alert(msg || '登录失败，请稍后重试')
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.login-container {
  background: #fff;
  border-radius: 16px;
  padding: 40px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.2);
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-header h1 {
  margin: 0 0 10px 0;
  font-size: 24px;
  color: #333;
}

.login-header p {
  margin: 0;
  color: #999;
  font-size: 14px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-size: 14px;
  font-weight: 500;
}

.form-control {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.3s;
  box-sizing: border-box;
}

.form-control:focus {
  outline: none;
  border-color: #667eea;
}

.login-btn {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.3s;
}

.login-btn:hover {
  opacity: 0.9;
}

.login-footer {
  text-align: center;
  margin-top: 20px;
}

.login-footer span {
  color: #667eea;
  font-size: 14px;
  cursor: pointer;
}
</style>